// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORMS_DEFAULT_REQUIRED_FIELD_ERROR = "Toto pole je povinn\u00e9.";
export const LAST_PERIOD_START = "Za\u010diatok poslednej men\u0161tru\u00e1cie";
export const PREGNANCY_CALCULATOR_FORM_SUBMIT = "Vypo\u010d\u00edtaj mi to";
export const PREGNANCY_CALCULATOR_FORM_TITLE = "Vypl\u0148 d\u00e1tum, ktor\u00fd pozn\u00e1\u0161:";
export const SIGNUP_DUE_DATE = "Term\u00edn p\u00f4rodu";
